<script>
    import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { commitHistory } from "@app/store/historyStore.svelte.js";
    import expandText from "@cclib/functions/quill/expandText.js";
    import { toast } from "@zerodevx/svelte-toast";
    import * as m from '@app/paraglide/messages.js';

    let isDisabled = $derived(!eventGroupState[projectState.selected] ||
        eventGroupState[projectState.selected].selected.length === 0 ||
        isSelectedEventGroupLocked());

    /* Expand makes the event wider which requires us to add a word to the longest line from a shorter line*/
    const expandEvent = function () {
        if (!eventGroupState[projectState.selected]) {
            return;
        }

        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        if (
            !eventGroupState[projectState.selected].selected ||
            eventGroupState[projectState.selected].selected.length === 0
        ) {
            return;
        }

        const egIdx = projectState.selected;
        const selected = [...eventGroupState[egIdx].selected];
        const maxChars = eventGroupState[egIdx].maxChars;

        commitHistory({
            name: "expand event(s)",
            eventGroup: egIdx,
            mutate: {
                eventGroupState: (draft) => {
                    selected.forEach((eventIndex) => {
                        const ev = draft[egIdx].events[eventIndex];
                        if (!ev?.text) {
                            return;
                        }
                        try {
                            ev.text = expandText(ev.text, maxChars);
                        } catch (err) {
                            console.error(err);
                        }
                    });
                },
            },
        });

        const firstIdx = selected[0];
        if (firstIdx !== undefined && window.quillEditor) {
            const text = eventGroupState[egIdx].events[firstIdx]?.text;
            if (text && window.quillEditor.getSemanticHTML() !== text) {
                let delta = window.quillEditor.clipboard.convert({ html: text });
                window.quillEditor.setContents(delta, "silent");
                window.quillEditor.formatLine(
                    0,
                    9999,
                    "align",
                    eventGroupState[egIdx].events[firstIdx].alignment === "left"
                        ? ""
                        : eventGroupState[egIdx].events[firstIdx].alignment,
                    "silent",
                );
            }
        }
    };
</script>

<li class="nav-item" title={m.expand_title()}>
    <a
        class="nav-link"
        href="#!/"
        id="expand-event-btn"
        role="button"
        aria-label={m.expand_aria_label()}
        aria-disabled={isDisabled}
        class:disabled={isDisabled}
        onclick={expandEvent}
    ><i class="bi bi-distribute-vertical"></i></a>
</li>
